import { RealTimeReport_Table } from 'views/index';
import FilterInfo from './FilterInfo';
import UserInfo from './UserInfo';

export { FilterInfo, UserInfo, RealTimeReport_Table as Table };



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/components/index.js